import { Reducer } from 'redux';
import { LodgeEnquiryActionTypes, LodgeEnquiryState } from 'types';

const initialState: LodgeEnquiryState = {
  address: undefined,
  errors: undefined,
  submitting: false,
  job: undefined,
  enquiry: {},
  shape: undefined,
  shapeArea: undefined,
  channelTestMode: undefined
};

const reducer: Reducer<LodgeEnquiryState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_INIT: {
      return {
        ...state,
        job: undefined,
        enquiry: {}
      };
    }
    case LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_REQUEST: {
      return {
        ...state,
        submitting: true
      };
    }
    case LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_SUCCESS: {
      return {
        ...state,
        submitting: false,
        job: action.payload?.Job,
        enquiry: action.payload?.Enquiry
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_LODGE_ENQUIRY_DETAILS: {
      return {
        ...state,
        job: undefined,
        enquiry: {},
        shape: undefined
      };
    }
    case LodgeEnquiryActionTypes.FETCH_LODGE_ENQUIRY_FAILURE: {
      return {
        ...state,
        submitting: false,
        errors: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_ENQUIRY_ADDRESS: {
      return {
        ...state,
        address: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_SHAPE: {
      return {
        ...state,
        shape: action.payload?.shape,
        shapeArea: action.payload?.area
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_SHAPE: {
      return {
        ...state,
        shape: undefined,
        shapeArea: undefined,
        address: undefined
      };
    }
    case LodgeEnquiryActionTypes.FETCH_LAST_ENQUIRY_REQUEST: {
      return {
        ...state,
        lastEnquiry: undefined
      };
    }
    case LodgeEnquiryActionTypes.FETCH_LAST_ENQUIRY_SUCCESS: {
      const lastEnquiry = action.payload;
      if (lastEnquiry?.authorityId === null) {
        if (lastEnquiry?.otherAuthorityName !== '') {
          lastEnquiry.authorityId = 'other';
        } else {
          lastEnquiry.authorityId = 'private';
        }
      }
      if (lastEnquiry?.Address?.line1 === lastEnquiry?.userReference) {
        lastEnquiry.userReference = undefined;
      }
      return {
        ...state,
        lastEnquiry
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_LAST_ENQUIRY: {
      return {
        ...state,
        lastEnquiry: undefined
      };
    }
    case LodgeEnquiryActionTypes.FETCH_ENQUIRY_JOB_REQUEST: {
      return {
        ...state,
        submitting: true
      };
    }
    case LodgeEnquiryActionTypes.FETCH_ENQUIRY_JOB_SUCCESS: {
      return {
        ...state,
        submitting: false,
        job: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SANDBOX_TESTING_MODE:
      return {
        ...state,
        channelTestMode: action.payload
      };
    case LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_START: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'saving'
        }
      };
    }
    case LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_SUCCESS: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'saved'
        }
      };
    }
    case LodgeEnquiryActionTypes.SAVE_ENQUIRY_PRESETS_FAILURE: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'error',
          error: action.payload
        }
      };
    }
    case LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_START: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'deleting'
        }
      };
    }
    case LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_SUCCESS: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'deleted'
        }
      };
    }
    case LodgeEnquiryActionTypes.DELETE_ENQUIRY_PRESETS_FAILURE: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'error',
          error: action.payload
        }
      };
    }
    case LodgeEnquiryActionTypes.GO_TO_ENQUIRY_PRESETS: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'initial',
          shape: state.shape,
          shapeArea: state.shapeArea,
          address: state.address,
          formData: action.payload
        }
      };
    }
    case LodgeEnquiryActionTypes.RETURN_FROM_ENQUIRY_PRESETS: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'returning'
        }
      };
    }
    case LodgeEnquiryActionTypes.COMPLETED_RETURN_FROM_ENQUIRY_PRESETS: {
      const { presets } = state;
      return {
        ...state,
        presets: {
          ...presets,
          status: 'returned'
        }
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_ENQUIRY_PRESETS: {
      return {
        ...state,
        presets: undefined
      };
    }
    case LodgeEnquiryActionTypes.SET_LIVE_AREA: {
      return {
        ...state,
        liveArea: action.payload
      };
    }
    case LodgeEnquiryActionTypes.UPDATE_LODGE_ENQUIRY_REFERRAL: {
      const { enquiry } = state;
      if (enquiry?.Referrals) {
        const oldReferralIndex = enquiry?.Referrals.findIndex(
          (referral: any) => referral.id === action.payload.id
        );
        const oldReferral = enquiry.Referrals[oldReferralIndex];
        enquiry.Referrals[oldReferralIndex] = {
          ...oldReferral,
          ...action.payload
        };
      }

      return {
        ...state,
        enquiry: {
          ...enquiry
        }
      };
    }
    case LodgeEnquiryActionTypes.PRE_POPULATE_ENQUIRY_DATA: {
      return {
        ...state,
        prePopulatedData: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as LodgeEnquiryReducer };
